export const START_FETCHING_CUSTOMER_PAYMENTS = 'START_FETCHING_CUSTOMER_PAYMENTS';
export const STOP_FETCHING_CUSTOMER_PAYMENTS = 'STOP_FETCHING_CUSTOMER_PAYMENTS';
export const FETCHED_CUSTOMER_PAYMENTS = 'FETCHED_CUSTOMER_PAYMENTS';
